// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import {
  CasesCountAndCreate,
  ObjectCases,
  Modal,
  AssignedToResponsibilityIdentity as AssignedTo,
  ToolbarItem,
  NavLink
} from '../'

import { ReadOnlyContext } from '../../context'

import { hasResponsibility } from '../../utils'


export default class CreditApplicationPropertiesBar extends PureComponent {
  static propTypes = {
    creditApplication: PropTypes.string.isRequired,  // can be either file or request
    assignedToIdentity: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    }),
    client: PropTypes.shape({
      id: PropTypes.string.isRequired,
      identity: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired
      })
    }),
    creditApplicationStatus: PropTypes.string,
    openCases: PropTypes.array.isRequired,
    resolvedCases: PropTypes.array.isRequired,
    onCreateCaseClick: PropTypes.func.isRequired,
    assignedToSave: PropTypes.func
  }

  state = {
    reassign: false,
    showStatusChangeOptions: false
  }

  closeStatusDropdownAndReset = () => (
    this.setState({ showStatusChangeOptions: false })
  )

  render() {
    let { creditApplication, assignedToIdentity, client, creditApplicationStatus } = this.props

    return (
      <div id='toolbar' className='action-toolbar'>
        <div>
          <ApplicationFor
            id={client.identity.id}
            firstName={client.identity.firstName}
            lastName={client.identity.lastName}
          />
        </div>
        <div>
          {assignedToIdentity !== undefined &&
            <ReadOnlyContext.Consumer>
              {readOnly => (
                <AssignedTo
                  identityId={assignedToIdentity && assignedToIdentity.id}
                  firstName={assignedToIdentity && assignedToIdentity.firstName}
                  lastName={assignedToIdentity && assignedToIdentity.lastName}
                  responsibility='loanapplication_create'
                  assignedToSave={identityId => {
                    this.setState({ reassign: false })
                    this.props.assignedToSave(identityId)
                  }}
                  dropdownOpen={this.state.reassign}
                  closeDropdown={() => this.setState({ reassign: false })}
                  noUnassign={true}
                  onClick={() => this.setState({ reassign: true })}
                  disabled={(creditApplicationStatus === 'UNDER_REVIEW' &&
                    !hasResponsibility('self', 'loanapplication_reassign_reviewer'))
                  }
                />
              )}
            </ReadOnlyContext.Consumer>
          }
        </div>
        <div className='slds-col_bump-left slds-grid' style={{ borderLeft: `1px solid #f1f1f2` }}>
          <CasesCountAndCreate
            numberOfOpenCases={this.props.openCases.length}
            numberOfResolvedCases={this.props.resolvedCases.length}
            onCaseCreateClick={this.props.onCreateCaseClick}
            openCasesRender={ref =>
              <Modal
                ref={ref}
                heading='Open cases'
                body={
                  <ObjectCases
                    object={creditApplication}
                    status='open'
                    numberOfRecordsPerPage={5}
                  />
                }
                elementId='toolbar'
              />
            }
            resolvedCasesRender={ref =>
              <Modal
                ref={ref}
                heading='Resolved cases'
                body={
                  <ObjectCases
                    object={creditApplication}
                    status='resolved'
                    numberOfRecordsPerPage={5}
                  />
                }
                elementId='toolbar'
              />
            }
          />
        </div>
      </div>
    )
  }
}

const ApplicationFor = ({ id, firstName, lastName }) => (
  <ToolbarItem
    label='Application for'
    value={
      <NavLink to={`/os/identity/${id}`}>
        {`${firstName} ${lastName}`}
      </NavLink>
    }
  />
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-properties-bar/index.js